import { Template, TemplateTabs } from "./same-height-template";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Utility/Same Height",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-same-height",
    args: {
        anchorNav: false,
    },
    argTypes: {
        anchorNav: {
            control: "boolean",
            description: "Enable or disable anchor navigation",
            table: {
                type: { summary: "boolean" },
                defaultValue: { summary: false },
            },
        },
    },
};

export const Default = Template.bind({});

export const InsideTabs = TemplateTabs.bind({});
InsideTabs.args = {
    anchorNav: false,
};

export const InsideAnchorNavTabs = TemplateTabs.bind({});
InsideAnchorNavTabs.args = {
    anchorNav: true,
};
